// extracted by mini-css-extract-plugin
export default {"header-popover":"Ts1qE","button":"cr4AE","arrow-open":"ROLjM"};